import { defineNuxtPlugin } from "#app";
import PrimeVue from "primevue/config";
import { i18nInstance } from "./i18n";

import Button from "primevue/button";
import OverlayPanel from 'primevue/overlaypanel';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import DataView from 'primevue/dataview';
import InputSwitch from "primevue/inputswitch";
import InputMask from 'primevue/inputmask';
import InputOtp from 'primevue/inputotp';
import AutoComplete from 'primevue/autocomplete';


export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(PrimeVue,
        {
            ripple: false, unstyled: false, locale: {
                "startsWith": i18nInstance.global.t("bnpl:prime_vue.locales.startsWith"),
                "contains": i18nInstance.global.t("bnpl:prime_vue.locales.contains"),
                "notContains": i18nInstance.global.t("bnpl:prime_vue.locales.notContains"),
                "endsWith": i18nInstance.global.t("bnpl:prime_vue.locales.endsWith"),
                "equals": i18nInstance.global.t("bnpl:prime_vue.locales.equals"),
                "notEquals": i18nInstance.global.t("bnpl:prime_vue.locales.notEquals"),
                "noFilter": i18nInstance.global.t("bnpl:prime_vue.locales.noFilter"),
                "filter": i18nInstance.global.t("bnpl:prime_vue.locales.filter"),
                "lt": i18nInstance.global.t("bnpl:prime_vue.locales.lt"),
                "lte": i18nInstance.global.t("bnpl:prime_vue.locales.lte"),
                "gt": i18nInstance.global.t("bnpl:prime_vue.locales.gt"),
                "gte": i18nInstance.global.t("bnpl:prime_vue.locales.gte"),
                "dateIs": i18nInstance.global.t("bnpl:prime_vue.locales.dateIs"),
                "dateIsNot": i18nInstance.global.t("bnpl:prime_vue.locales.dateIsNot"),
                "dateBefore": i18nInstance.global.t("bnpl:prime_vue.locales.dateBefore"),
                "dateAfter": i18nInstance.global.t("bnpl:prime_vue.locales.dateAfter"),
                "custom": i18nInstance.global.t("bnpl:prime_vue.locales.custom"),
                "clear": i18nInstance.global.t("bnpl:prime_vue.locales.clear"),
                "apply": i18nInstance.global.t("bnpl:prime_vue.locales.apply"),
                "matchAll": i18nInstance.global.t("bnpl:prime_vue.locales.matchAll"),
                "matchAny": i18nInstance.global.t("bnpl:prime_vue.locales.matchAny"),
                "addRule": i18nInstance.global.t("bnpl:prime_vue.locales.addRule"),
                "removeRule": i18nInstance.global.t("bnpl:prime_vue.locales.removeRule"),
                "accept": i18nInstance.global.t("bnpl:prime_vue.locales.accept"),
                "reject": i18nInstance.global.t("bnpl:prime_vue.locales.reject"),
                "choose": i18nInstance.global.t("bnpl:prime_vue.locales.choose"),
                "upload": i18nInstance.global.t("bnpl:prime_vue.locales.upload"),
                "cancel": i18nInstance.global.t("bnpl:prime_vue.locales.cancel"),
                "completed": i18nInstance.global.t("bnpl:prime_vue.locales.completed"),
                "pending": i18nInstance.global.t("bnpl:prime_vue.locales.pending"),
                "dayNames": ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],
                "dayNamesShort": ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
                "dayNamesMin": ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
                "monthNames": ["Január", "Február", "Március", "Április", "Május", "Június", "Július", "Augusztus", "Szeptember", "Október", "November", "December"],
                "monthNamesShort": ["jan.", "febr.", "márc.", "ápr.", "máj.", "jún.", "júl.", "aug.", "szept.", "okt.", "nov.", "dec."],
                "chooseYear": i18nInstance.global.t("bnpl:prime_vue.locales.chooseYear"),
                "chooseMonth": i18nInstance.global.t("bnpl:prime_vue.locales.chooseMonth"),
                "chooseDate": i18nInstance.global.t("bnpl:prime_vue.locales.chooseDate"),
                "prevDecade": i18nInstance.global.t("bnpl:prime_vue.locales.prevDecade"),
                "nextDecade": i18nInstance.global.t("bnpl:prime_vue.locales.nextDecade"),
                "prevYear": i18nInstance.global.t("bnpl:prime_vue.locales.prevYear"),
                "nextYear": i18nInstance.global.t("bnpl:prime_vue.locales.nextYear"),
                "prevMonth": i18nInstance.global.t("bnpl:prime_vue.locales.prevMonth"),
                "nextMonth": i18nInstance.global.t("bnpl:prime_vue.locales.nextMonth"),
                "prevHour": i18nInstance.global.t("bnpl:prime_vue.locales.prevHour"),
                "nextHour": i18nInstance.global.t("bnpl:prime_vue.locales.nextHour"),
                "prevMinute": i18nInstance.global.t("bnpl:prime_vue.locales.prevMinute"),
                "nextMinute": i18nInstance.global.t("bnpl:prime_vue.locales.nextMinute"),
                "prevSecond": i18nInstance.global.t("bnpl:prime_vue.locales.prevSecond"),
                "nextSecond": i18nInstance.global.t("bnpl:prime_vue.locales.nextSecond"),
                "am": i18nInstance.global.t("bnpl:prime_vue.locales.am"),
                "pm": i18nInstance.global.t("bnpl:prime_vue.locales.pm"),
                "today": i18nInstance.global.t("bnpl:prime_vue.locales.today"),
                "weekHeader": i18nInstance.global.t("bnpl:prime_vue.locales.weekHeader"),
                "firstDayOfWeek": i18nInstance.global.t("bnpl:prime_vue.locales.firstDayOfWeek"),
                "dateFormat": i18nInstance.global.t("bnpl:prime_vue.locales.dateFormat"),
                "weak": i18nInstance.global.t("bnpl:prime_vue.locales.weak"),
                "medium": i18nInstance.global.t("bnpl:prime_vue.locales.medium"),
                "strong": i18nInstance.global.t("bnpl:prime_vue.locales.strong"),
                "passwordPrompt": i18nInstance.global.t("bnpl:prime_vue.locales.passwordPrompt"),
                "emptyFilterMessage": i18nInstance.global.t("bnpl:prime_vue.locales.emptyFilterMessage"),
                "searchMessage": i18nInstance.global.t("bnpl:prime_vue.locales.searchMessage"),
                "selectionMessage": i18nInstance.global.t("bnpl:prime_vue.locales.selectionMessage"),
                "emptySelectionMessage": i18nInstance.global.t("bnpl:prime_vue.locales.emptySelectionMessage"),
                "emptySearchMessage": i18nInstance.global.t("bnpl:prime_vue.locales.emptySearchMessage"),
                "emptyMessage": i18nInstance.global.t("bnpl:prime_vue.locales.emptyMessage"),
                "aria": {
                    "trueLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.trueLabel"),
                    "falseLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.falseLabel"),
                    "nullLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.nullLabel"),
                    "star": i18nInstance.global.t("bnpl:prime_vue.locales.aria.star"),
                    "stars": i18nInstance.global.t("bnpl:prime_vue.locales.aria.stars"),
                    "selectAll": i18nInstance.global.t("bnpl:prime_vue.locales.aria.selectAll"),
                    "unselectAll": i18nInstance.global.t("bnpl:prime_vue.locales.aria.unselectAll"),
                    "close": i18nInstance.global.t("bnpl:prime_vue.locales.aria.close"),
                    "previous": i18nInstance.global.t("bnpl:prime_vue.locales.aria.previous"),
                    "next": i18nInstance.global.t("bnpl:prime_vue.locales.aria.next"),
                    "navigation": i18nInstance.global.t("bnpl:prime_vue.locales.aria.navigation"),
                    "scrollTop": i18nInstance.global.t("bnpl:prime_vue.locales.aria.scrollTop"),
                    "moveTop": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveTop"),
                    "moveUp": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveUp"),
                    "moveDown": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveDown"),
                    "moveBottom": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveBottom"),
                    "moveToTarget": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveToTarget"),
                    "moveToSource": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveToSource"),
                    "moveAllToTarget": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveAllToTarget"),
                    "moveAllToSource": i18nInstance.global.t("bnpl:prime_vue.locales.aria.moveAllToSource"),
                    "pageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.pageLabel"),
                    "firstPageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.firstPageLabel"),
                    "lastPageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.lastPageLabel"),
                    "nextPageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.nextPageLabel"),
                    "previousPageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.previousPageLabel"),
                    "rowsPerPageLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.rowsPerPageLabel"),
                    "jumpToPageDropdownLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.jumpToPageDropdownLabel"),
                    "jumpToPageInputLabel": i18nInstance.global.t("bnpl:prime_vue.locales.aria.jumpToPageInputLabel"),
                    "selectRow": i18nInstance.global.t("bnpl:prime_vue.locales.aria.selectRow"),
                    "unselectRow": i18nInstance.global.t("bnpl:prime_vue.locales.aria.unselectRow"),
                    "expandRow": i18nInstance.global.t("bnpl:prime_vue.locales.aria.expandRow"),
                    "collapseRow": i18nInstance.global.t("bnpl:prime_vue.locales.aria.collapseRow"),
                    "showFilterMenu": i18nInstance.global.t("bnpl:prime_vue.locales.aria.showFilterMenu"),
                    "hideFilterMenu": i18nInstance.global.t("bnpl:prime_vue.locales.aria.hideFilterMenu"),
                    "filterOperator": i18nInstance.global.t("bnpl:prime_vue.locales.aria.filterOperator"),
                    "filterConstraint": i18nInstance.global.t("bnpl:prime_vue.locales.aria.filterConstraint"),
                    "editRow": i18nInstance.global.t("bnpl:prime_vue.locales.aria.editRow"),
                    "saveEdit": i18nInstance.global.t("bnpl:prime_vue.locales.aria.saveEdit"),
                    "cancelEdit": i18nInstance.global.t("bnpl:prime_vue.locales.aria.cancelEdit"),
                    "listView": i18nInstance.global.t("bnpl:prime_vue.locales.aria.listView"),
                    "gridView": i18nInstance.global.t("bnpl:prime_vue.locales.aria.gridView"),
                    "slide": i18nInstance.global.t("bnpl:prime_vue.locales.aria.slide"),
                    "slideNumber": i18nInstance.global.t("bnpl:prime_vue.locales.aria.slideNumber"),
                    "zoomImage": i18nInstance.global.t("bnpl:prime_vue.locales.aria.zoomImage"),
                    "zoomIn": i18nInstance.global.t("bnpl:prime_vue.locales.aria.zoomIn"),
                    "zoomOut": i18nInstance.global.t("bnpl:prime_vue.locales.aria.zoomOut"),
                    "rotateRight": i18nInstance.global.t("bnpl:prime_vue.locales.aria.rotateRight"),
                    "rotateLeft": i18nInstance.global.t("bnpl:prime_vue.locales.aria.rotateLeft")
                }
            }
        });
    nuxtApp.vueApp.component('Button', Button);
    nuxtApp.vueApp.component('OverlayPanel', OverlayPanel);
    nuxtApp.vueApp.component('InputText', InputText);
    nuxtApp.vueApp.component('InputNumber', InputNumber);
    nuxtApp.vueApp.component('Dropdown', Dropdown);
    nuxtApp.vueApp.component('Calendar', Calendar);
    nuxtApp.vueApp.component('TabView', TabView);
    nuxtApp.vueApp.component('TabPanel', TabPanel);
    nuxtApp.vueApp.component('DataView', DataView);
    nuxtApp.vueApp.component('InputSwitch', InputSwitch);
    nuxtApp.vueApp.component('InputMask', InputMask);
    nuxtApp.vueApp.component('InputOtp', InputOtp);
    nuxtApp.vueApp.component('AutoComplete', AutoComplete);
});
